module.exports = __webpack_public_path__ + "static/img/semi-heavy-tanker-white.a7c8031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-tanker-white.svg
// module id = WWK1
// module chunks = 82